import { User } from './user';

export class Importer {
  name!: string;
  description?: string;
  address?: string;
  country?: string;
  email?: string;
  phone_number?: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  static getSortColumns() {
    return [
      'name',
      'country',
      'description',
      'address',
      'email',
      'phone_number',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.address = data.address;
    this.country = data.country;
    this.description = data.description;
    this.email = data.email;
    this.phone_number = data.phone_number;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
